module.exports = __webpack_public_path__ + "images/new-kid-b2b0f043c2b946642649f59d7af9ddd9.png";